import axios from "axios"
import http, { HttpResponse, PaganitionRequest, PaganitionResponse } from "../../bundle/libs/http"


export interface DocumentDTO{
    id: string
    filename: string
    project_id: string
    size: number
    mimetype: string
    user_id: string
    created_at: string
    status: "PENDING" | "WAITING_FOR_REVIEW" | "IN_PROGRESS" | "WAITING_PAYMENT" | "COMPLETED" | "FAILED"
    translation_progress_percentage?: number
}

export interface PaymentInfo{
    payment_status: "UNPAID" | "PAID",
    transaction_id: string
}

export interface PricingInfo{
    price: number
    currency: string
    pro_price: number
}

export interface PreviewInfo{
    original_preview_images: string[]
    translated_preview_images: string[]
    image_count: number
}

export interface DocumentMetrics{
    page_count: number
    character_count: number
}

export interface DocumentDetailDTO{
    id: string

    filename: string
    project_id: string
    size: number
    mimetype: string
    user_id: string
    created_at: string
    updated_at: string
    status: "PENDING" | "WAITING_FOR_REVIEW" | "IN_PROGRESS" | "WAITING_PAYMENT" | "COMPLETED" | "FAILED"
    payment_status: "UNPAID" | "PAID"
    pricing_info: PricingInfo,
    preview_info: PreviewInfo,
    payment_info: PaymentInfo
    partial_translation: boolean
    document_metrics: DocumentMetrics
    translation_progress_percentage?: number
    target_language?: string
}


export interface DocumentRequest{
    project_id?: string
    skip?: number
    limit?: number
}

export interface DocumentCreateRequest{
    filename: string
    project_id?: string
    object_key: string
    size: number
    mimetype: string
    target_language?: string
}

export type DocumentEditRequest = DocumentIdRequest & DocumentCreateRequest

export interface DocumentIdRequest{
    id: string
    include_previews?: number
}

export interface DocumentPresignedUrlRequest{
    filename: string
    project_id?: string
    content_type: string
}

export interface DocumentPresignedUrlResponse{
    upload_url: string
    fields: {[key: string]: string}
    file_key: string
}

export interface PaginationResponse{
    data: DocumentDTO[]
    total: number
    skip: number
    limit: number
}

const list = async (request: DocumentRequest) => {
    const res = (await axios.get(`/documents`, {params: request})).data as PaginationResponse
    // http.checkState(res)
    return res
}

const create = async (request: DocumentCreateRequest) => {
    const res = (await axios.post("/documents", request)).data as DocumentDTO
    // http.checkState(res)
    return res
}

const detail = async (request: DocumentIdRequest) => {
    let url = `/documents/${request.id}`
    if(request.include_previews){
        url += `?include_previews=${request.include_previews}`
    }
    const res = (await axios.get(url)).data as DocumentDetailDTO
    // http.checkState(res)
    return res
}

const update = async (request: DocumentEditRequest) => {
    const res = (await axios.post("/Document/update", request)).data as HttpResponse<void>
    http.checkState(res)
    return res
}

const remove = async (request: DocumentIdRequest) => {
    const res = (await axios.delete(`/documents/${request.id}`)).data as HttpResponse<void>
    return res
}

const generatePresignedUrl = async (request: DocumentPresignedUrlRequest) => {
    const res = (await axios.post("/documents/presigned-url", request)).data as DocumentPresignedUrlResponse
    return res
}

const checkout = async (request: DocumentIdRequest) => {
    const res = (await axios.post(`/documents/${request.id}/checkout`)).data as {checkout_url: string}
    return res.checkout_url
}

const getDownloadUrl = async (request: DocumentIdRequest, format: 'pdf' | 'pptx') => {
    let path = `/documents/${request.id}/download`
    if(format === 'pptx'){
        path += `-${format}`
    }
    const res = (await axios.get(path)).data as {download_url: string}
    return res.download_url
}

export default {
    list,
    create,
    detail,
    update,
    remove,
    generatePresignedUrl,
    checkout,
    getDownloadUrl
}